module.exports = __webpack_public_path__ + "img/iphone-x-mockup.b99a3da8.svg";